import { isTreatmentEnabled } from '@vp/ctc-reader';
import { logNR } from './nr-logging';
import { getChatConfig } from './chat-config-utils';

export const isProAdvantageCustomer = () => {
  try {
    const { env } = getChatConfig();
    if (!env?.includes('develop')) {
      if (isTreatmentEnabled('proadvantage_basic_care') || isTreatmentEnabled('proadvantage_premium_care')) {
        console.info('Pro Advantage Customer detected');
        return true;
      }
    }
    return false;
  } catch (err) {
    const error = err as Error;
    logNR('CA_ERROR', { errorMessage: error.message, errorStack: error.stack });
  }
  return false;
};

export const proAdvLocales = ['en-us', 'en-ca'];
